import { render, staticRenderFns } from "./FilterBoardTypes.vue?vue&type=template&id=a28836e0&scoped=true"
import script from "./FilterBoardTypes.vue?vue&type=script&lang=js"
export * from "./FilterBoardTypes.vue?vue&type=script&lang=js"
import style0 from "./FilterBoardTypes.vue?vue&type=style&index=0&id=a28836e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a28836e0",
  null
  
)

export default component.exports